import React, {useEffect, useState} from "react";
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import locale from "locale";

const CPSettingSelect = ({
    label,
    property,
    eventValue,
    defaultValue,
    list,
    hint = '',
    localeKey = 'settings',
    onChange,
}) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(eventValue || defaultValue);
    }, [eventValue]);

    function handleChangeValue(value) {
        setValue(value);
        onChange({[property]: value});
    }

    return (
        <FormGroup controlId="formControlsSelect">
            <ControlLabel style={{fontWeight: 'normal'}}>
                {label}
            </ControlLabel>
            <FormControl
                value={value}
                componentClass="select"
                placeholder="select"
                onChange={(e) => handleChangeValue(e.target.value)}
            >
                {
                    Object.values(list).map((item) => (
                        <option key={item} value={item}>
                            {locale(`${localeKey}.${item}`)}
                        </option>
                    ))
                }
            </FormControl>
            {
                !!hint &&
                <p>
                    <i>({hint})</i>
                </p>
            }
        </FormGroup>
    );
};

export default CPSettingSelect;
